
import { paths } from "@/router/routes";
import { BLUEMETERING_PARTNER_ID, partnerModule } from "@/store/modules/partner";
import { subscriptionModule } from "@/store/modules/subscription";
import { RemoteData } from "@/store/utils/remote-data";
import { UserError } from "@/types/user-error";
import { Vue, Component } from "vue-property-decorator";
import { Feature } from "zaehlerfreunde-proto-types/features_pb";
import { Partner } from "zaehlerfreunde-proto-types/partners_pb";

@Component
export default class ConnectDeviceReminder extends Vue {
  @partnerModule.Getter isPartnerBlueMetering: boolean;
  @subscriptionModule.Getter includedFeatures: Feature[];

  onConnectDeviceClicked(): void {
    if (this.isPartnerBlueMetering) {
      this.$router.push(`${paths.platform.connectDevice}/${BLUEMETERING_PARTNER_ID}`);
    } else {
      this.$router.push(paths.platform.connectDevice);
    }
  }
}
